import { render, staticRenderFns } from "./Yinshiyun.vue?vue&type=template&id=c5c81be4&scoped=true&"
import script from "./Yinshiyun.vue?vue&type=script&lang=js&"
export * from "./Yinshiyun.vue?vue&type=script&lang=js&"
import style0 from "./Yinshiyun.vue?vue&type=style&index=0&id=c5c81be4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c81be4",
  null
  
)

component.options.__file = "Yinshiyun.vue"
export default component.exports